import { useHandleFetchError } from "../../../error-handler";
import { useGetCountries } from "../../../service/api";
import { SelectInput } from "./SelectInput";

type Props = {
  name: string;
  isDisabled?: boolean;
};

export const SelectCurrencyInput = ({ name, isDisabled }: Props) => {
  const { data: countries, error: getCountriesError } = useGetCountries();

  const currencies = new Set(
    countries?.filter((c) => c.enabled).map((c) => c.currency)
  );

  const countryOptions = Array.from(currencies)
    .sort((a, b) => a.localeCompare(b))
    .map((o) => ({
      label: o,
      value: o,
    }));

  countryOptions.unshift({
    label: "None",
    value: "",
  });

  useHandleFetchError(getCountriesError);

  return (
    <SelectInput
      name={name}
      label="Currency"
      options={countryOptions}
      placeholder="Choose currency"
      isDisabled={isDisabled}
      helperText={isDisabled ? "You cannot change the currency." : undefined}
    />
  );
};
